import OMOSettingsLayout from "../layout/OMOSettingsLayout";
import OMOConnectSettingsForm from "../form/OMOConnectSettingsForm";

const OMOConnectSettingPage = () => {

    return (
        <OMOSettingsLayout title="오모 Connect 신청">
            <div className="items-center">
                <div className="flex-col gap-[32px] border bg-white p-[32px] rounded-[16px]">
                    <OMOConnectSettingsForm isConnect={true} />
                </div>
            </div>
        </OMOSettingsLayout>
    );
};
export default OMOConnectSettingPage;
